module.exports = __webpack_public_path__ + "img/Aaron_O_5.66d50ded.jpg";